
import MPrintInvitaion from "@/components/print_invitation/MPrintHeader.vue";
import { LoginInfo } from "@/store";
import QrcodeVue from "qrcode.vue";
import { Options, Vue } from "vue-class-component";
import { State } from "@/store/helper";
import { School } from "@/entities/school";
import {
  getSchoolAiServiceName,
  isSucceedLoginSchoolDocId
} from "@/constants/succeedLoginConfig";

type DataType = {
  key: string;
  schoolDocId: string | null;
  schoolName: string;
  studentName: string;
  loginId: string;
  password: string;
  schoolId: string;
  code: string;
};

@Options({
  components: {
    MPrintInvitaion,
    QrcodeVue
  }
})
export default class PrintInvitation extends Vue {
  clipboardStatusType = "clipboard-copy";
  clipboardMessage = "招待文面をコピー";

  @State("selectedLoginInfos") loginInfos!: LoginInfo[];
  @State("school") school!: School | null;

  SCHOOL_AI_LOGIN_URL = "https://school-ai-app.mingaku.net/login_for_student";
  SCHOOL_AI_MANUAL_URL =
    "https://mingaku.notion.site/fd5ef296e7748241ab5c01cba8dc6ccd";
  SCHOOL_AI_PRINT_GUIDE_URL =
    "https://mingaku.notion.site/AI-fd5ef296e7748241ab5c01cba8dc6ccd";

  get datas(): DataType[] {
    return this.loginInfos.map(info => {
      return {
        key: `${info.schoolId}:${info.loginId}:${info.studentName}`,
        schoolDocId: info.schoolDocId ?? this.school?.ref.id ?? null,
        schoolName: info.schoolName,
        studentName: info.studentName,
        loginId: info.loginId,
        password: info.password,
        schoolId: info.schoolId,
        code: `${info.loginId} ${info.password} ${info.schoolId}`
      };
    });
  }

  serviceNameOf(data: DataType): string {
    return getSchoolAiServiceName(data.schoolDocId);
  }

  isSucceedLoginData(data: DataType): boolean {
    return isSucceedLoginSchoolDocId(data.schoolDocId);
  }

  async messageCopy() {
    const message = this.loginInfos
      .map(
        info => `「${info.studentName}（${info.schoolName}）」さん

スクールAIへようこそ！
まずは以下のログインページにアクセスし、ログイン情報を入力してください。

・。・。・。・。・。・。・。・。・。・。・。・。・。・。
■ スクールAI ログインページ
${this.SCHOOL_AI_LOGIN_URL}

■ ログイン情報
スクールID：${info.schoolId}
生徒ログインID：${info.loginId}
パスワード：${info.password}

・。・。・。・。・。・。・。・。・。・。・。・。・。・。
■ 困ったときは

分からないことがあったら、公式ガイドを確認するか先生に相談しましょう。

▼スクールAI公式ガイド
${this.SCHOOL_AI_MANUAL_URL}
`
      )
      .join("\n\n\n\n");

    await navigator.clipboard.writeText(message);
    this.clipboardStatusType = "clipboard-check";
    this.clipboardMessage = "コピーしました";
    await new Promise(resolve => setTimeout(resolve, 1000));
    this.clipboardStatusType = "clipboard-copy";
    this.clipboardMessage = "招待文面をコピー";
  }

  print() {
    window.print();
  }

  shrinkTextToFit(element: HTMLElement): void {
    const text = element.querySelector("span") as HTMLElement | null;
    if (!text) {
      return;
    }

    const maxFontSize = parseFloat(window.getComputedStyle(text).fontSize);
    const minFontSize = 13;
    text.style.fontSize = `${maxFontSize}px`;

    const containerStyle = window.getComputedStyle(element);
    const availableWidth =
      element.clientWidth -
      Number.parseFloat(containerStyle.paddingLeft) -
      Number.parseFloat(containerStyle.paddingRight);

    if (text.scrollWidth <= availableWidth) {
      return;
    }

    const fittedSize = Math.max(
      minFontSize,
      maxFontSize * (availableWidth / text.scrollWidth) * 0.98
    );
    text.style.fontSize = `${fittedSize}px`;
  }

  created() {
    if (this.datas.length > 0) {
      let title = "スクールAI帳票";
      this.datas.forEach(
        data => (title += `_${data.loginId} ${data.studentName}`)
      );
      document.title = title;
    }
  }

  mounted(): void {
    const containers = Array.from(
      document.querySelectorAll(".school-ai-student-name")
    ) as HTMLElement[];

    containers.forEach(container => {
      this.shrinkTextToFit(container);
    });
  }
}
